import { Button } from "@/src/components/buttons";
import { closeDrawer, openDrawer } from "@/src/components/dialogs";
import { Patient, Appointment, Exam } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId, getUserId } from "@/src/utils/utils";
import { ExamDocumentsCompartment } from "../documents/examDocumentsCompartment";
import { openExam } from "./openExam";
import {
  ExamContentDrawer,
  ExamContentTitle,
} from "./openExamVisualisationDrawer";

export async function openExamVisualisation(
  patient: Patient,
  appointment: Appointment,
  onConfirm: (appointment: Appointment) => void
) {
  let exam = (await apiFetch("appointments", "loadAppointmentItem", {
    appointmentId: appointment.id,
    itemId: getItemId(appointment.item),
  })) as Exam | null;

  console.log("appointment", {
    appointmentId: appointment.id,
    item: appointment.item,
    exam,
  });

  if (!exam) return;

  let documentTemplates = await apiFetch("documentTemplates", "loadMany", {
    referenceId: getItemId(exam.reference),
    types: ["standard", "letter"],
  });

  async function onLocalClick() {
    console.log("appointment", appointment);
    await openExam(patient, appointment, (appointment) => {
      onConfirm(appointment);
      closeDrawer("examVisualisation");
      openExamVisualisation(patient, appointment, onConfirm);
    });
  }


  await openDrawer({
    id: "examVisualisation",
    title: (
      <ExamContentTitle
        exam={exam}
        onClick={async () => {
          onLocalClick();
        }}
      ></ExamContentTitle>
    ),
    additionalClasses: ["small"],
    content: (
      <div className="c1 gap20">
        <ExamContentDrawer exam={exam} onClick={onLocalClick} />
        {documentTemplates?.length != 0 && exam.status == "finished" && (
          <div className="mtop20">
            <ExamDocumentsCompartment exam={exam} patient={exam.patient!} />
          </div>
        )}
      </div>
    ),
    footer: (
      <div className="c2 gap10 p15">
        <Button
          type={"tertiary"}
          onClick={() => {
            closeDrawer("examVisualisation");
          }}
        >
          Fermer
        </Button>

        <Button
          onClick={() => {
            onLocalClick();
          }}
        >
          Modifier
        </Button>
      </div>
    ),
  });
}
